import {invalidateOnSuccess, omneticApi} from '@dms/api/base';

import {
  FinancialProductsResponseBodySchema,
  GetBusinessCaseFinancialProductsApiArgSchema,
  UpdateBusinessCaseFinancialProductPreferenceApiArgSchema,
  type FinancialProductsResponseBody,
  type GetBusinessCaseFinancialProductsApiArg,
  type GetBusinessCaseFinancialProductsApiResponse,
  type UpdateBusinessCaseFinancialProductPreferenceApiArg,
} from './types';

const businessCaseFinancialProductsBaseApi = omneticApi.enhanceEndpoints({
  addTagTypes: ['BusinessCaseFinancialProducts'],
});

export const businessCaseFinancialProductsApi =
  businessCaseFinancialProductsBaseApi.injectEndpoints({
    overrideExisting: false,
    endpoints: (build) => ({
      getBusinessCaseFinancialProducts: build.query<
        GetBusinessCaseFinancialProductsApiResponse,
        GetBusinessCaseFinancialProductsApiArg
      >({
        query: (queryArg) => ({
          url: `/dms/v1/business-case/${queryArg.businessCaseId}/financial-products`,
        }),
        // A write to one business case must not evict another case's products.
        providesTags: (result, error, queryArg) => [
          {type: 'BusinessCaseFinancialProducts', id: queryArg.businessCaseId},
        ],
        extraOptions: {
          requestSchema: GetBusinessCaseFinancialProductsApiArgSchema,
          responseSchema: FinancialProductsResponseBodySchema,
        },
      }),
      updateBusinessCaseFinancialProductPreference: build.mutation<
        FinancialProductsResponseBody,
        UpdateBusinessCaseFinancialProductPreferenceApiArg
      >({
        query: (queryArg) => ({
          url: `/dms/v1/business-case/${queryArg.businessCaseId}/financial-product-preference`,
          method: 'PUT',
          body: queryArg.requestBody,
        }),
        invalidatesTags: invalidateOnSuccess(
          (_result, queryArg: UpdateBusinessCaseFinancialProductPreferenceApiArg) => [
            {type: 'BusinessCaseFinancialProducts' as const, id: queryArg.businessCaseId},
          ]
        ),
        extraOptions: {
          requestSchema: UpdateBusinessCaseFinancialProductPreferenceApiArgSchema,
          responseSchema: FinancialProductsResponseBodySchema,
        },
      }),
    }),
  });

export const {
  useGetBusinessCaseFinancialProductsQuery,
  useUpdateBusinessCaseFinancialProductPreferenceMutation,
} = businessCaseFinancialProductsApi;
